"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="222832" className="flex w-full justify-center items-center px-4">
        <div className="flex gap-4">
          <div className="h-4 w-16 bg-muted animate-pulse rounded-md" />
          <div className="h-4 w-16 bg-muted animate-pulse rounded-md" />
        </div>
        <div className="flex gap-4 ml-8">
          <div className="h-4 w-16 bg-muted animate-pulse rounded-md" />
          <div className="h-4 w-16 bg-muted animate-pulse rounded-md" />
        </div>
      </div>;
  }
  return <div className="hidden md:flex items-center">
      <NavigationMenu viewport={false} className="max-w-full w-full justify-center">
        <NavigationMenuList className="w-full justify-center gap-4">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="text-sm font-medium text-foreground hover:text-primary transition-colors tracking-widest uppercase">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>
    </div>;
}
function MobileNavItems({
  setIsOpen
}: {
  setIsOpen: (v: boolean) => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 py-4">
        <div className="h-8 w-32 bg-muted animate-pulse rounded-md" />
        <div className="h-8 w-32 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <div className="flex flex-col gap-4 py-6">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-lg font-medium text-foreground hover:text-primary transition-colors block py-2" onClick={() => setIsOpen(false)}>
            {item.label}
          </Link>
        </div>)}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="capçalera-principal" className="sticky top-0 z-50 w-full overflow-x-hidden transition-all duration-400 ease-[cubic-bezier(0.22,1,0.36,1)] border-b border-transparent bg-background">
      <div className="container mx-auto max-w-full px-6 lg:px-12 h-20 relative flex items-center justify-center gap-8">
        
        {}
        <div className="z-10 shrink-0">
          <Link to="/" className="!bg-transparent">
            <div className="bg-background border border-border p-2 rounded-full shadow-lg">
              <img src="https://salvatserveisrurals.10web.cloud/wp-content/uploads/2026/04/logo-SSR_verd-scaled.png" alt="Salvat Serveis Rurals" className="!m-0 !p-0 !h-[60px] !w-[60px] object-contain" />
            </div>
          </Link>
        </div>

        {}
        <MenuProvider menu_id="20" className="hidden md:block">
          <DesktopNav />
        </MenuProvider>

        {}
        <div className="md:hidden absolute right-6 flex items-center z-20">
          <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-foreground hover:bg-transparent hover:text-primary" aria-label="Toggle menu">
            {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
          </Button>
        </div>
      </div>

      {}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full z-50 bg-background/95 backdrop-blur-lg border-b border-border shadow-lg md:hidden flex flex-col px-6 pb-6 animate-in slide-in-from-top-2 duration-300">
          <MenuProvider menu_id="20">
            <MobileNavItems setIsOpen={setIsMobileMenuOpen} />
          </MenuProvider>
        </div>}
    </section>;
}